export default __webpack_public_path__ + "39a41a9bc8408c651ec12724dc148dd2.png";